import {Col, Row} from "react-bootstrap";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {
  assumeIdentity,
  getCompany,
  getCompanyEmployees,
  getStates,
  saveArchiveCompany,
  saveCompany,
  saveEmployee
} from "../common/api/WebApi";
import {displayPhone, formatDate} from "../common/Utils";
import {ButtonGroup, Card, CardContent, Chip, Select, TextareaAutosize} from "@mui/material";
import ManageCompanyModal from "./ManageCompanyModal";
import ManageEmployeeModal from "../employee/ManageEmployee";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import Footer from "../Footer";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Meta from "../common/Meta";
import MDButton from "../../components/MDButton";
import Icon from "@mui/material/Icon";
import PageLoading from "../common/PageLoading";
import AdminImportCustomers from "./AdminImportCustomers";
import MenuItem from "@mui/material/MenuItem";
import Confirm from "../common/Confirm";
import AdminAssignMembershipModal from "./AdminAssignMembershipModal";
import CompanyNotes from "./CompanyNotes";
import {bulkImportMemberships} from "../common/api/CustomerProfileApi";

export default function Company(props) {

  const [context, setContext] = useContext(AppContext);

  const navigate = useNavigate();
  const location = useLocation();

  let {guid} = useParams();
  const [refreshCompany, setRefreshCompany] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formInvalid, setFormInvalid] = useState(false);
  const [onEdit, setOnEdit] = useState(guid == null);
  const [archiveCompany, setArchiveCompany] = useState(false);

  const [newCompany, setNewCompany] = useState(guid == null);
  const [company, setCompany] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [originalCompany, setOriginalCompany] = useState({});
  const [states, setStates] = useState([]);
  const [manageEmployee, setManageEmployee] = useState(false);
  const [quickSearchOpen, setQuickSearchOpen] = useState(false);
  const [importCsvMembers, setImportCsvMembers] = useState(false);

  const [importMembersInput, setImportMembersInput] = useState('');

  const [employee, setEmployee] = useState(null);
  const [importType, setImportType] = useState('-1');
  const [confirmation, setConfirmation] = useState(null);

  const handleConfirmArchive = async () => {

    setSaving(true);

    let result = await saveArchiveCompany(company);

    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setConfirmation(null);
      setArchiveCompany(false);
      navigate('/companies/list')
    }
  }

  const updateImportType = (type) => {
    setImportType(type);
  }

  const startArchive = () => {
    let _confirmation = {
      title: 'Archive ' + company.companyName + '?',
      message: 'Confirm archive ' + company.companyName + '?',
      entity: company
    }
    setConfirmation(_confirmation);
    setArchiveCompany(true);
  }

  useEffect(() => {
    getStates().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setStates(result);
      }
    });
  }, []);

  useEffect(() => {
    setCompany({});
  }, [location]);

  // useEffect(() => {
  //   document.body.addEventListener('keydown', keyPressListener);
  //   return () => {
  //     document.body.removeEventListener('keydown', keyPressListener);
  //   };
  // }, [keyPressListener]);

  useEffect(() => {
    if (!guid) {
      setOnEdit(true);
      setNewCompany(true);
    } else {
      getCompanyFn().then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          let c = {...result};
          setCompany({...c});
          setOriginalCompany({...c});
          setRefreshCompany(false);
        }
      });

      getCompanyEmployeesFn().then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setEmployees(result);
        }
      });
    }
  }, [guid, refreshCompany]);

  const getCompanyFn = async () => {
    return await getCompany(guid);
  }

  const getCompanyEmployeesFn = async () => {
    return await getCompanyEmployees(guid);
  }

  const todoFn = () => {
    alert('todo')
  };

  const handleCloseEmployee = () => {
    setEmployee(null);
    setManageEmployee(false);
  };

  const handleSaveEmployee = async (employee) => {
    setSaving(true);
    employee.companyGuid = company.guid;
    let result = await saveEmployee(employee);
    setSaving(false);

    handleCloseEmployee();

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      getCompanyEmployeesFn().then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          setEmployees(result);
        }
      });
    }

  };

  const startManageEmployeeFn = (e) => {
    let _emp = {...e};
    e.newEmployee = true;
    setEmployee(e);
  };

  const handleSaveCompany = async (company) => {

    setSaving(true);

    let result = await saveCompany(company);

    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshCompany(true);
      setOnEdit(false);

      if (result.guid && guid !== result.guid) {
        navigate('./' + result.guid);
      }
    }
  }

  const handleClose = () => {
    setOnEdit(false);
    if (newCompany) {
      navigate('/');
    } else {
      setCompany({...originalCompany});
    }
  };

  const assumeIdentityFn = async (employee) => {
    let result = await assumeIdentity(employee.guid);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setContext({sessionUser: null, refreshIdentity: true});
      window.location.href = '/';
    }
  };

  const [processing, setProcessing] = useState(false);
  const [importResponse, setImportResponse] = useState(null);

  const saveCustomerInput = () => {
    setProcessing(true);
    setImportResponse(null);
    bulkImportMemberships({
      csvData: importMembersInput,
      companyGuid: company?.guid,
      fileData: '.csv'
    }, importType).then(result => {
      setProcessing(false);
      setImportResponse(result);
      alert("Done importing Memberhips!");
      setImportCsvMembers(false);
    });
  }

  return (
    <>
      <DashboardLayout>
        <Meta pageTitle={'View Company'}/>
        <ContextSearchNavbar title="View Company"/>
        {!(company?.guid) && <>
          <PageLoading/>
        </>}

        {company?.guid && <>
          <Meta pageTitle={'View Company - ' + company?.companyName}/>
          <Grid container spacing={2} mt={2}>
            <Grid item sm={7}>
              <Card>
                <MDBox display="block" justifyContent="space-between" alignItems="center" pt={2} px={2}>
                  <MDButton
                    onClick={(e) => {
                      e.preventDefault();
                      setOnEdit(true);
                    }}
                    className={'pull-right'}
                    color="primary">
                    Edit
                  </MDButton>

                  <MDButton
                    onClick={(e) => {
                      e.preventDefault();
                      startArchive();
                    }}
                    className={'pull-right mx-2'}
                    color="info">
                    Delete
                  </MDButton>

                  <h5>
                    <MDTypography fontWeight="medium">
                      {company.companyName}
                    </MDTypography>
                  </h5>
                </MDBox>
                <MDBox p={2}>
                  <MDBox mb={2} lineHeight={1}>
                    <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                      Member since: &nbsp;
                    </MDTypography>

                    <MDTypography variant="button" color="text" fontWeight="light">
                      {formatDate(company.createDate)}
                      <p>{company.address1} {company.address2}
                        <br/>{company.city}, {company.state.stateName} {company.postalCode}</p>
                      {company.primaryPhone &&
                        <p>{displayPhone(company.primaryPhone)}</p>
                      }
                      {company.cafeEnabled && <>
                        <p><b><Icon>check</Icon>Cafe Enabled</b></p>
                      </>}

                    </MDTypography>

                    <div className={'clear-both d-block'}>

                      <p>
                        <b>Billing Status:</b>
                        &nbsp;{company?.billType?.name}
                      </p>

                      <Divider/>
                      <MDBox>

                        <Select
                          autoWidth
                          sx={{
                            padding: '5px 10px',
                            marginRight: '5px'
                          }}
                          value={importType}
                          onChange={
                            (e) => {
                              updateImportType(e.target.value);
                            }
                          }>
                          <MenuItem value={'-1'}>Import</MenuItem>
                          <MenuItem value={'leap360'}>Leap360</MenuItem>
                          <MenuItem value={'aluvii'}>Aluvii</MenuItem>
                          <MenuItem value={'wellnessliving'}>Wellness Living</MenuItem>
                          <MenuItem value={'momence'}>Momence</MenuItem>
                          <MenuItem value={'pcs'}>Party Center Software</MenuItem>
                          <MenuItem value={'generic'}>Generic</MenuItem>
                        </Select>

                        <Divider/>
                      </MDBox>

                    </div>

                    {company?.guid &&
                      <>
                        <div className={'d-block'} style={{
                          display:'block',
                          width:'100%'
                        }}>
                          <ButtonGroup className={'mt-4 pull-right'}>
                            <MDButton color={'secondary'} size={'small'} className={'mx-1'}
                                      onClick={() => {
                                        setQuickSearchOpen(true);
                                      }}>Bulk Assign Memberships</MDButton>
                            <MDButton color={'secondary'} size={'small'}
                                      onClick={() => {
                                        setImportCsvMembers(!importCsvMembers);
                                      }}>From Csv</MDButton>
                          </ButtonGroup>
                          <div style={{
                            display:'block',
                            width:'100%',
                            clear:'both'
                          }}>&nbsp;</div>
                        </div>
                        {importCsvMembers && <div className={'clear-both d-block'}>

                          <div className="form-group">

                            <pre>email,pass_name,number_passes,bill_start_date
                              <br/>test@email.com,Monthly Member,10,01/31/2026
                            </pre>


                            <TextareaAutosize
                              autoComplete="off"
                              minRows={5}
                              onChange={(e) => {
                                setImportMembersInput(e.target.value);
                              }}
                              className="form-control" id="desc"
                              placeholder={'test@email.com,Monthly Member,10,01/31/2026'}/>
                          </div>

                          <MDButton color={'primary'} className={'pull-right my-2'} size={'small'}
                                    disabled={!importMembersInput?.length || processing}
                                    onClick={() => {
                                      saveCustomerInput();
                                    }}>{processing ? 'Saving' : 'Save'} Memberships</MDButton>

                        </div>}
                      </>
                    }

                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
            <Grid item sm={5}>
              <Card>
                <CardContent>
                  <h5>Employees
                    <MDButton
                      color="secondary"
                      size="small"
                      onClick={(e) => {
                        e.preventDefault();
                        setManageEmployee(true);
                        startManageEmployeeFn({});
                      }}
                      className={'pull-right'}><Icon>add</Icon>&nbsp;Add
                      Employee</MDButton>
                  </h5>

                  <ul className={'list-group mt-2'}>
                    {employees?.map((employee, index) => {
                        return (
                          <li
                            className={'list-group-item xxx-cursor-pointer hover-shadow'}
                            key={index}>
                            <Row>
                              <Col sm={6}>
                                {employee.firstName} {employee.lastName} {employee.companyAdmin && <>
                                <br/>
                                <Chip variant="outlined"
                                      color="secondary" label={'Admin'}/>
                              </>}
                              </Col>
                              <Col sm={6}>
                                <MDButton
                                  color="secondary"
                                  size="small"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    assumeIdentityFn(employee)
                                  }}
                                  className={'pull-right'}>
                                  <span className={'fa fa-user-plus'}></span>&nbsp;Assume Identity
                                </MDButton>
                              </Col>
                            </Row>
                          </li>
                        )
                      }
                    )}
                  </ul>

                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid container my={1} spacing={2}>
            <Grid item sm={12}>
              <Card>
                <CardContent>
                  <CompanyNotes guid={company?.guid}/>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid container my={1} spacing={2}>
            <Grid item sm={12}>
              <Card>
                <CardContent>
                  <h5>Billing History</h5>
                  <Divider/>
                  <p>TODO</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {
            <>

              {importType !== '-1' && <AdminImportCustomers
                show={importType !== '-1'}
                companyGuid={guid}
                importType={importType}
                handleClose={() => {
                  setImportType('-1');
                }} callback={(msg, close) => {
                alert('Done! ' + msg);
                if (close) {
                  setImportType('-1');
                }
              }} isNew={false}
              />}

              <ManageCompanyModal
                company={company}
                show={onEdit}
                saving={saving}
                handleSaveCompany={handleSaveCompany}
                handleClose={handleClose}/>

              {employee && <ManageEmployeeModal
                employee={employee}
                show={manageEmployee}
                saving={saving}
                handleSaveEmployee={handleSaveEmployee}
                handleClose={handleCloseEmployee}/>
              }

              {company && archiveCompany && <>
                <Confirm confirmation={confirmation}
                         show={archiveCompany}
                         saving={saving}
                         handleConfirm={handleConfirmArchive}
                         handleSave={() => {
                           setConfirmation(null);
                           setArchiveCompany(false);
                         }}/>
              </>}

            </>
          }
        </>
        }

        <Footer mt={5}/>

      </DashboardLayout>

      {quickSearchOpen && <>
        <AdminAssignMembershipModal company={company} show={quickSearchOpen} handleClose={() => {
          setQuickSearchOpen(false);
        }} handleSave={() => {
          setQuickSearchOpen(false);
        }}/>
      </>}
    </>
  );
}